module.exports = __webpack_public_path__ + "img/cover.f46abc3a.jpg";